import { render, staticRenderFns } from "./TopicRaiseModal.vue?vue&type=template&id=22100a44&"
import script from "./TopicRaiseModal.vue?vue&type=script&lang=js&"
export * from "./TopicRaiseModal.vue?vue&type=script&lang=js&"
import style0 from "./TopicRaiseModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports